import { z } from 'zod'

export function createCustomerDisplayEventSchemas() {
    const item = z.looseObject({
        name: z.string(),
        qty: z.number(),
        price: z.number(),
        discount: z.number(),
        subtotal: z.number(),
    })
    return {
        customer_display_cart: z.looseObject({
            type: z.literal('customer_display_cart').optional(),
            items: z.array(item),
            total: z.number(),
            customer_name: z.string(),
            item_count: z
                .number()
                .refine(Number.isInteger, 'Expected an integer'),
        }),
        customer_display_checkout: z.looseObject({
            type: z.literal('customer_display_checkout').optional(),
            order_id: z.string().optional(),
            order_code: z.string(),
            total: z.number(),
            paid: z.number(),
            change: z.number(),
            method: z.string(),
        }),
        customer_display_qr: z.looseObject({
            type: z.literal('customer_display_qr').optional(),
            order_id: z.string(),
            order_code: z.string(),
            customer_name: z.string(),
            total_amount: z.number(),
        }),
        customer_display_paid: z.looseObject({
            type: z.literal('customer_display_paid').optional(),
            order_id: z.string(),
            order_code: z.string(),
            total_amount: z.number(),
            paid_amount: z.number(),
        }),
        customer_display_clear: z
            .looseObject({
                type: z.literal('customer_display_clear').optional(),
            })
            .nullish(),
    }
}

type DisplaySchemas = ReturnType<typeof createCustomerDisplayEventSchemas>
export type CustomerDisplayCartEvent = z.infer<
    DisplaySchemas['customer_display_cart']
>
export type CustomerDisplayCartItem = CustomerDisplayCartEvent['items'][number]
export type CustomerDisplayCheckoutEvent = z.infer<
    DisplaySchemas['customer_display_checkout']
>
export type CustomerDisplayQREvent = z.infer<
    DisplaySchemas['customer_display_qr']
>
export type CustomerDisplayPaidEvent = z.infer<
    DisplaySchemas['customer_display_paid']
>
export type CustomerDisplaySyncRequest = {
    display_user_id: string
    expected_revision?: number
} & (
    | { type: 'cart'; data: CustomerDisplayCartEvent }
    | { type: 'checkout'; data: CustomerDisplayCheckoutEvent }
    | { type: 'qr'; data: CustomerDisplayQREvent }
    | {
          type: 'clear'
          data?: z.infer<DisplaySchemas['customer_display_clear']>
      }
)
